import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { errorMessageAdapter } from '../../../../adapters';
import { Card, CustomTooltip } from '../../../../components/atoms';
import { AuthService } from '../../../../services/AuthService';
import { useAuth } from '../../../../store/auth';
import { errorToast, successToast } from '../../../../utils/toasts';
import { useApi } from '../../../../services/hooks/apiHook';
import { AxiosInstance } from 'axios';
import { defaultColors, defaultLogo, defaultButton, defaultBackground, defaultBorder } from '../../../../styles/style-guide';
import { ColorInput } from './ColorInput';
import { MainCustomButton } from '../../../../components/Buttons';
import { styleGuideSelector, updateStyleColors } from '../../../../store/globalSlice/styleSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AiOutlineClose } from 'react-icons/ai';
import { useAppSelector } from '../../../../hooks/hooksRedux';
import { RootState } from '../../../../store';
import { UpdateColorPayload } from '../../../../services/Interfaces/IAccountService';
import { InstancesServices } from '../../../../services/InstancesServices';
import { useColors } from '../../../../hooks/useColors';

export type FormDataType = {
  logo: File | null;
  primaryColor: string;
  secondaryColor: string;
  tertiaryColor: string;
  whiteColor: string;
  otherColor: string;
  hoverColor: string;
  buttonPrimary: string;
  backgroundPrimary: string;
  backgroundSecondary: string;
  backgroundThird: string;
  backgroundHover: string;
  borderPrimary: string;
  borderSecondary: string;
};


const StyleConfiguration = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const api: AxiosInstance = useApi();
  const dispatch = useDispatch();
  const [logoPreview, setLogoPreview] = useState<string | null>(null);
  const { updateUseColors, updateUseLogo } = useColors()
  const { colors, button, border } = useAppSelector((state: RootState) => state.styleGuide.data);
  const { logo } = useAppSelector((state: RootState) => state.styleGuide.data);
  const logoUrlOld = logo

  // const validationSchema = Yup.object().shape({
  //   logo: Yup.mixed().required('Logo is required'),
  //   primaryColor: Yup.string().required(),
  //   secondaryColor: Yup.string().required(),
  //   tertiaryColor: Yup.string().required(),
  //   whiteColor: Yup.string().required(),
  //   otherColor: Yup.string().required(),
  //   hoverColor: Yup.string().required(),
  //   buttonPrimary: Yup.string().required(),
  //   backgroundPrimary: Yup.string().required(),
  //   backgroundSecondary: Yup.string().required(),
  //   backgroundThird: Yup.string().required(),
  //   backgroundHover: Yup.string().required()
  // });

  const {
    control,
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors }
  } = useForm<FormDataType>({
    // resolver: yupResolver(validationSchema),
    defaultValues: {
      primaryColor: defaultColors.primary,
      secondaryColor: defaultColors.secondary,
      whiteColor: defaultColors.white,
      // otherColor: defaultColors.other,
      // hoverColor: defaultColors.hover,
      buttonPrimary: defaultButton.primary,
      backgroundPrimary: defaultBackground.primary,
      backgroundSecondary: defaultBackground.secondary,
      backgroundThird: defaultBackground.third,
      backgroundHover: defaultBackground.hover,
      borderPrimary: defaultBorder.primary,
      borderSecondary: defaultBorder.primary

    }
  });

  console.log('logo', logo);
  console.log('logoOld', logoUrlOld);


  const handleChange = async (data: FormDataType) => {
    try {
      dispatch(updateStyleColors({
        colors: {
          primary: data.primaryColor,
          secondary: data.secondaryColor,
          third: data.tertiaryColor,
          white: data.whiteColor,
          other: data.otherColor,
          hover: data.hoverColor
        },
        button: {
          primary: data.buttonPrimary
        },
        border: {
          primary: data.borderPrimary,
          secondary: data.borderSecondary
        },
        background: {
          primary: data.backgroundPrimary,
          secondary: data.backgroundSecondary,
          third: data.backgroundThird,
          hover: data.backgroundHover
        }
      }));

      if (data.logo && data.logo) {
        const file = data.logo;
        const logoUrl = URL.createObjectURL(file);
        dispatch(updateStyleColors({ logo: logoUrl }));
      }

      reset();
      successToast(t('environment.styleSaved'));
    } catch (e) {
      errorToast(errorMessageAdapter(e));
    }
  };

  const handleLogoDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files && files[0]) {
      setValue('logo', files[0]);
      const preview = URL.createObjectURL(files[0]);
      setLogoPreview(preview);
      dispatch(updateStyleColors({ logo: preview }));
    }
  };

  const handleChangeButton = async (data: FormDataType) => {
    try {

      const colorsPayload: UpdateColorPayload[] = [
        { type: 'text', order: 1, color: data.primaryColor },
        { type: 'text', order: 2, color: data.secondaryColor },
        { type: 'text', order: 3, color: data.whiteColor },
        { type: 'button', order: 1, color: data.buttonPrimary },
        { type: 'border', order: 1, color: data.borderPrimary }
      ];

      await updateUseColors(colorsPayload);
      dispatch(updateStyleColors({
        colors: {
          primary: data.primaryColor,
          secondary: data.secondaryColor,
          white: data.whiteColor,

        },
        button: {
          primary: data.buttonPrimary
        },
        border: {
          primary: data.borderPrimary,

        }
      }));

      const file = data.logo;
      if (file && logoPreview) {
        await updateUseLogo(file);
      }

      reset();
    } catch (e) {
      errorToast(errorMessageAdapter(e));
    }
  };

  useEffect(() => {
    reset({
      primaryColor: colors.primary,
      secondaryColor: colors.secondary,
      whiteColor: colors.white,
      buttonPrimary: button.primary,
      borderPrimary: border.primary
    });
  }, [colors, button, border, reset]);

  return (
    <Card.Root className="w-full">
      <Card.Header>
        <h3 className="text-lg font-medium">{t('titles.ttlBasicConfig')}</h3>
      </Card.Header>

      <Card.Content>
        <form className="flex flex-col gap-6" onSubmit={handleSubmit(handleChange)}>
          {/* Upload da logo */}
          <div className="flex flex-col gap-1">
            <div className="flex gap-1">
              <label className="w-max text-md font-medium">{t('config.Logo')}:</label>
              <CustomTooltip content={t('titles.ttlTooltipFormatImg')} />
            </div>
            <div
              onDrop={handleLogoDrop}
              onDragOver={(e) => e.preventDefault()}
              className="border border-dashed border-gray-400 p-4 rounded-md text-center cursor-pointer"
              onClick={() => document.getElementById('logoUpload')?.click()}
            >
              <input
                id="logoUpload"
                type="file"
                accept="image/*"
                {...register('logo')}
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (file) {
                    setValue('logo', file);
                    const preview = URL.createObjectURL(file);
                    setLogoPreview(preview);
                    dispatch(updateStyleColors({ logo: preview }));
                  }
                }}
                hidden
              />
              {logoPreview ? (
                <div className="relative w-full flex justify-center items-center">
                  <img src={logoPreview} alt={t('environment.logoPreview') ?? ''} className="h-20 object-contain" />

                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      setLogoPreview(null);
                      dispatch(updateStyleColors({ logo: defaultLogo }));
                      setValue('logo', undefined as any);
                    }}
                    className="absolute top-2 right-2 bg-white hover:bg-gray-100 text-black p-1 rounded-full shadow-md"
                    title={t('environment.removeImage') ?? ''}
                  >
                    <AiOutlineClose size={16} />
                  </button>
                </div>
              ) : (
                <p>{t('config.UploadImageFile')}</p>
              )}
            </div>
          </div>
          {errors.logo && <p className="text-red-500 text-sm">{errors.logo.message}</p>}
          <div className="grid grid-cols-3 gap-10">
            <div className="w-min">
              <label className="w-max text-md font-medium">{t('labels.lblPrimaryColor')}:</label>
              <div className="flex flex-col gap-6">
                <ColorInput name="primaryColor" control={control} label={t('config.ColorPrimary')} onChangePreview={(color) => dispatch(updateStyleColors({ colors: { primary: color } }))} />
                <ColorInput name="secondaryColor" control={control} label={t('config.ColorSecondary')} onChangePreview={(color) => dispatch(updateStyleColors({ colors: { secondary: color } }))} />
                <ColorInput name="whiteColor" control={control} label={t('config.ColorTertiary')} onChangePreview={(color) => dispatch(updateStyleColors({ colors: { white: color } }))} />
                {/* <ColorInput name="hoverColor" control={control} label="Hover" onChangePreview={(color) => dispatch(updateStyleColors({ colors: { hover: color } }))} /> */}
              </div>
            </div>
            <div className="w-max">
              <label className="w-max text-md font-medium">{t('labels.lblButtonColor')}:</label>
              <ColorInput name="buttonPrimary" control={control} label={t('config.ColorPrimary')} onChangePreview={(color) => dispatch(updateStyleColors({ button: { primary: color } }))} />
            </div>
            <div className="w-min">
              <label className="w-max text-md font-medium">{t('labels.lblBorderColor')}:</label>
              <ColorInput name="borderPrimary" control={control} label={t('config.ColorPrimary')} onChangePreview={(color) => dispatch(updateStyleColors({ border: { primary: color } }))} />
            </div>
          </div>


          <MainCustomButton text={t('others.othSave')} onClick={handleSubmit(handleChangeButton)} />
        </form>
      </Card.Content>
    </Card.Root>
  );
};

export { StyleConfiguration };
